const footerLinks = [
  { name: "Home", href: "/" },
  { name: "Careers", href: "/" },
  { name: "Pricing", href: "/" },
  { name: "Community", href: "/" },
  { name: "Products", href: "/" },
  { name: "Privacy Policy", href: "/" },
  { name: "About Us", href: "/" },
];

export default footerLinks;
